import type { AuthUser } from '@/types/auth';
import type {
  PlatformEventCategory,
  PlatformEventType,
} from '@/platform/events/EventTypes';

export type PlatformEventSeverity =
  'information' | 'low' | 'medium' | 'high' | 'critical';

export type PlatformActorType =
  'user' | 'system' | 'backgroundWorker' | 'scheduler' | 'service';

export interface PlatformEventActor {
  id?: string;
  displayName: string;
  actorType: PlatformActorType;
}

export interface PlatformEvent {
  id: string;
  type: PlatformEventType;
  category: PlatformEventCategory;
  occurredAt: string;
  actor: PlatformEventActor;
  resource: string;
  resourceId?: string;
  details: string;
  severity: PlatformEventSeverity;
  environment: string;
  product: string;
  ipAddress: string;
  metadata?: Record<string, string | number | boolean | null>;
  correlationId?: string;
  sessionId?: string;
}

export interface PlatformEventInput extends Omit<
  PlatformEvent,
  'id' | 'occurredAt'
> {
  id?: string;
  occurredAt?: string;
}

export function toPlatformActor(
  user: AuthUser | null,
  fallbackName: string,
): PlatformEventActor {
  if (!user) {
    return {
      displayName: fallbackName,
      actorType: 'system',
    };
  }

  return {
    id: user.id,
    displayName: user.displayName,
    actorType: 'user',
  };
}
